import { render, staticRenderFns } from "./editType.vue?vue&type=template&id=e5c3ab5c&"
import script from "./editType.vue?vue&type=script&lang=js&"
export * from "./editType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports